export var getDomain = function getDomain(url) {
  var hostname = null;

  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  } // Find & remove port number


  hostname = hostname.split(':')[0]; // Find & remove "?"

  hostname = hostname.split('?')[0];
  return hostname;
};
export var getRootDomain = function getRootDomain(url) {
  var domain = getDomain(url);
  var splitArr = domain.split('.');
  var arrLen = splitArr.length; // Extracting the root domain here

  if (arrLen > 1 && arrLen < 3) {
    return "".concat(splitArr[arrLen - 2], ".").concat(splitArr[arrLen - 1]);
  } else if (arrLen > 2) {
    return "".concat(splitArr[arrLen - 3], ".").concat(splitArr[arrLen - 2], ".").concat(splitArr[arrLen - 1]);
  }

  return domain;
};
export var getBaseDomain = function getBaseDomain(url) {
  var domain = getDomain(url);
  var splitArr = domain.split('.');
  var arrLen = splitArr.length; // Extracting the root domain here

  return "".concat(splitArr[arrLen - 2], ".").concat(splitArr[arrLen - 1]);
};
export var getDomainItems = function getDomainItems(url) {
  var domain = getDomain(url);
  return domain.split('.');
};

var getCurrentUrl = function getCurrentUrl() {
  return window.location.href;
};

export default {
  getDomain: getDomain,
  getRootDomain: getRootDomain,
  getBaseDomain: getBaseDomain,
  getDomainItems: getDomainItems,
  getCurrentUrl: getCurrentUrl
};
//# sourceMappingURL=domainName.js.map